import mixin from '../privates/utils/mixin';
import Background from './Background';
import ContainableMixin from './mixins/ContainableMixin';
import * as members from '../privates/privateMembers';

/**
 * @class Slide
 * @summary A `Slide` from a `Slideshow` that can contain other elements. 
 * @description
 *   You can open the Corvid Properties panel for the [`Slideshow`]($w.Slideshow.html) element
 *   but not for `Slide` elements. 
 * 
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @queryable
 * @viewername wysiwyg.viewer.components.BoxSlideShowSlide
 * @definitionId wysiwyg.viewer.components.BoxSlideShowSlide
 * @definitionId wysiwyg.viewer.components.StripContainerSlideShowSlide
 */
class Slide extends Background {


    /**
     * @member id
     * @label property
     * @syntax
     * get id(): string
     * @summary Gets the slide's ID.
     * @description
     *  The ID is the slide's unique identifier. It is used when selecting elements using the [`$w()`]($w.html#$w) function.
     *
     *  You cannot view or change a slide's `id` in the Corvid Properties panel. You can change a slide's [`name`]($w.Slide.html#name) instead.
     * 
     * 
     * @snippet [Slide-id.es6=Get the ID]
     * @type {external:String}
     * @memberof $w.Slide
     * @readonly
     * @override
     */



    /**
     * @member name
     * @label property
     * @syntax
     * get name(): string
     * @summary Gets the name of the slide.
     * @description
     *  A slide's `name` is used as a label for the slide.
     *
     *  A slide's `name` is set in the Editor using the [Manage Slides panel](https://support.wix.com/en/article/manage-slides).
     *  ![Manage Slides](images/manage_slides.png "Manage Slides")
     * @snippet [Slide-name.es6=Get a slide's name]
     * @type {external:String}
     * @memberof $w.Slide
     * @readonly
     * @instance
     */
    get name() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        return RMI.getData(compId).title;
    }

    toJSON() {
        const {id, type, global, background, rendered, name} = this;
        return {id, type, global, background: background.src, rendered, name};
    }
}

mixin(Slide.prototype, ContainableMixin.prototype);

export default Slide;
